export default __webpack_public_path__ + "static/media/cloud_upload.d6b20888.png";